export const USER_MENU_TYPE = {
  HEADER: "header",
  MAIN: "main",
  FOOTER: "footer",
  LOGOUT: "logout",
};

export const USER_FORM_FIELDS = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  GENDER: "gender",
  NATIONALITY: "nationality",
  IDENTITY_NO: "identityNo",
  EMAIL: "email",
  MOBILE_NO: "mobileNo",
  DOB: "dob",
};

export const AFFILIATE_FORM_FIELDS = {
  PRIMARY_EMAIL: "PRIMARYEMAIL",
  DOB: "dob",
  EMAIL: "email",
  FIRST_NAME: "firstname",
  LAST_NAME: "lastname",
};

export const USER_PROFILE_KEY = {
  NAME: "name",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  GENDER: "sex",
  DOB: "dob",
  MARITAL_STATUS: "mobileNo",
  IDENTITY: "identities",
  CONSENTS: "consents",
};

export const USER_CONSENT = {
  SUNDAY_AFFILIATE: "SUNDAY_AFFILIATE",
};
